import { recursiveTokenFilter } from "../../../Shared/utils/tokenReplacement";
import { stableDefaultKeyMap } from "./companyProviderDefaults";
/**
 * Groups an array of CompanyText objects into a nested object structure,
 * allowing direct access to text by section and title.
 * The result is an object where each section contains an object of titles mapped to their text.
 *
 * Example access: result["MyMealsPage"]["QuickSavePayBtnText"]
 */
export const groupCompanyTextBySectionAndTitle = (companyText) => {
    return companyText.reduce((acc, item) => {
        if (!acc[item.Section])
            acc[item.Section] = {};
        acc[item.Section][item.Title] = item.Text;
        return acc;
    }, {});
};
export const buildMaps = (data) => {
    // Build token map
    const tokenMap = (data === null || data === void 0 ? void 0 : data.tokenMap) ? new Map(Object.entries(data.tokenMap)) : new Map();
    if (tokenMap.size > 0)
        recursiveTokenFilter(data === null || data === void 0 ? void 0 : data.companyText, false, tokenMap);
    // Build key map
    const keyMap = (data === null || data === void 0 ? void 0 : data.keys)
        ? new Map(data.keys.map((k) => [k.KeyName, k.KeyValue]))
        : stableDefaultKeyMap;
    // Build company text by section and title
    const companyTextBySectionAndTitle = !data ? {} : groupCompanyTextBySectionAndTitle(data.companyText);
    return { tokenMap, keyMap, companyTextBySectionAndTitle };
};
